export default {
      id: "play_store-usage",
      viewBox: "0 0 170 50",
      url: "/" + "sprite.svg#play_store",
      toString: function () {
        return this.url;
      }
    }